module.exports = __webpack_public_path__ + "fonts/Gilroy-Light.73bfa12b.ttf";